// Unified quick action button used across all views
// Standard design: 14px icon, px-2.5 py-1.5 padding, rounded-lg, text-xs

const COLOR_CONFIG = {
  today: {
    text: 'text-accent',
    bg: 'bg-accent/10',
    hover: 'hover:bg-accent/20',
    // Monochrome mode: neutral default, themed on hover
    monoHover: 'hover:text-accent hover:bg-accent/15'
  },
  schedule: {
    text: 'text-weekly',
    bg: 'bg-weekly-light',
    hover: 'hover:bg-weekly/20',
    monoHover: 'hover:text-weekly hover:bg-weekly/15'
  },
  waiting: {
    text: 'text-amber-400',
    bg: 'bg-amber-500/10',
    hover: 'hover:bg-amber-500/20',
    monoHover: 'hover:text-amber-400 hover:bg-amber-500/15'
  },
  someday: {
    text: 'text-purple-400',
    bg: 'bg-purple-500/10',
    hover: 'hover:bg-purple-500/20',
    monoHover: 'hover:text-purple-400 hover:bg-purple-500/15'
  },
  done: {
    text: 'text-success',
    bg: 'bg-success-light',
    hover: 'hover:bg-success/20',
    monoHover: 'hover:text-success hover:bg-success/15'
  },
  delete: {
    text: 'text-red-400',
    bg: 'bg-red-500/10',
    hover: 'hover:bg-red-500/20',
    monoHover: 'hover:text-red-400 hover:bg-red-500/15'
  },
  project: {
    text: 'text-blue-400',
    bg: 'bg-blue-500/10',
    hover: 'hover:bg-blue-500/20',
    monoHover: 'hover:text-blue-400 hover:bg-blue-500/15'
  },
  oneOnOne: {
    text: 'text-green-400',
    bg: 'bg-green-500/10',
    hover: 'hover:bg-green-500/20',
    monoHover: 'hover:text-green-400 hover:bg-green-500/15'
  },
  goal: {
    text: 'text-monthly',
    bg: 'bg-monthly-light',
    hover: 'hover:bg-monthly/20',
    monoHover: 'hover:text-monthly hover:bg-monthly/15'
  },
  habit: {
    text: 'text-teal-400',
    bg: 'bg-teal-500/10',
    hover: 'hover:bg-teal-500/20',
    monoHover: 'hover:text-teal-400 hover:bg-teal-500/15'
  }
};

export default function QuickActionButton({
  icon: Icon,
  label,
  colorKey,
  isActive = false,
  disabled = false,
  onClick,
  iconOnly = false,
  monochrome = false  // Use neutral colors by default, show themed color on hover
}) {
  const colors = COLOR_CONFIG[colorKey] || COLOR_CONFIG.today;

  // Monochrome mode: neutral gray default, themed color on hover
  // Normal mode: themed colors always
  const useMonochrome = monochrome && !isActive;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        flex items-center gap-1 rounded-md border-none cursor-pointer
        transition-all duration-200
        ${iconOnly ? 'p-1' : 'px-1.5 py-1'}
        ${useMonochrome
          ? `text-text-secondary bg-surface-hover ${colors.monoHover}`
          : `${colors.text} ${colors.bg} ${colors.hover}`
        }
        ${isActive ? `ring-1 ring-current ${colors.text} ${colors.bg}` : ''}
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      {Icon && <Icon size={12} />}
      {!iconOnly && label && (
        <span className="text-[10px] whitespace-nowrap">{label}</span>
      )}
    </button>
  );
}

export { COLOR_CONFIG };
